import React, { useMemo } from 'react';
import { useTypedSelector } from '../Hooks/useTypedSelector';
import ProductListHeaderText from './ProductList.HeaderText';

const CategoryHeaderText = ({ description, richTextDescription }: { description: string, richTextDescription: string }) => {
  const { currentCategoryDescription } = useTypedSelector(
    (state) => state.productFiltering
  );

  const categoryDescription = useMemo(
    () =>
      currentCategoryDescription != ''
        ? currentCategoryDescription
        : (richTextDescription ? richTextDescription : description),
    [currentCategoryDescription, description, richTextDescription]
  );

  return categoryDescription ? (
    <ProductListHeaderText {...{ value: categoryDescription }} />
  ) : null;
};

export default CategoryHeaderText;
